import React from 'react';
import { IonModal } from '@ionic/react';
import './Modal.css';

interface ModalProps {
  /** Whether the modal is open */
  isOpen: boolean;
  /** Callback fired when modal should close */
  onClose: () => void;
  /** Modal content */
  children: React.ReactNode;
  /** Additional CSS class name */
  className?: string;
}

function Modal({
  isOpen,
  onClose,
  children,
  className = '',
}: ModalProps) {
  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onClose}
      backdropDismiss={false}
      className={`custom-modal ${className}`}
    >
      <div className="modal-content-wrapper">
        {children}
      </div>
    </IonModal>
  );
}

export default Modal;

